import { useContext } from "react";
import { AddressContainer } from "../../AddressContainer";
import { Typography } from "@mui/material";
import { FlexColBox } from "../../../common/components/Box/FlexColBox";
import { spacing } from "../../../styles/theme";
import { useTranslation } from "react-i18next";
import { Input } from "../../../common/components";
import { FormContext } from "../../../context";
import { CheckoutForm } from "../Cart";
import CartItemShipping from "./components/CartItemShipping";
import CartCheckoutPaymentOptions from "./components/CartCheckoutPaymentOptions";
import { TextArea } from "../../../common/components/TextArea/TextArea";
import CartCabonNeutral from "./components/CartCabonNeutral";
import CartClientDetails from "./components/CartClientDetails";
import { CheckoutStyles } from "./styles";

const CartCheckout = () => {
  const { t } = useTranslation();
  const { formik } = useContext(FormContext);
  const { poNumber, notes } = formik?.values as CheckoutForm;

  return (
    <FlexColBox gap={{ xs: spacing.mediumMobile, lg: spacing.mediumDesktop }}>
      <Typography variant="h1">{t("checkout.checkout")}</Typography>
      <AddressContainer />
      <CartItemShipping />
      <CartCheckoutPaymentOptions />
      <CartClientDetails />
      <FlexColBox
        gap={{ xs: spacing.groupingMobile, lg: spacing.groupingDesktop }}
        sx={CheckoutStyles.container}
      >
        <Typography variant="h2">{t("checkout.additional_options")}</Typography>
        <CartCabonNeutral />
        <Input
          name="poNumber"
          data-test="checkout.poNumber"
          value={poNumber}
          onChange={(e: any) =>
            formik?.setFieldValue("poNumber", e.target.value)
          }
          label={t("checkout.po_number")}
          autoComplete="off"
          fullWidth
          noDefaultValue
        />
        <TextArea
          name="notes"
          data-test="checkout.notes"
          value={notes}
          onChange={(e: any) => formik?.setFieldValue("notes", e.target.value)}
          label={t("checkout.notes")}
          autoComplete="off"
          fullWidth
          noMaxWidth
          minRows={2}
          noDefaultValue
        />
      </FlexColBox>
    </FlexColBox>
  );
};

export default CartCheckout;
